export default "__VITE_ASSET__ZkItEq8K__"